import script from "./FinanceSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./FinanceSidebar.vue?vue&type=script&setup=true&lang=js"

import "./FinanceSidebar.vue?vue&type=style&index=0&id=060c9f6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-060c9f6c"]])

export default __exports__